import { render, staticRenderFns } from "./schoolTeacher.vue?vue&type=template&id=d0729704&scoped=true&"
import script from "./schoolTeacher.vue?vue&type=script&lang=js&"
export * from "./schoolTeacher.vue?vue&type=script&lang=js&"
import style0 from "./schoolTeacher.vue?vue&type=style&index=0&id=d0729704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0729704",
  null
  
)

export default component.exports